import sagaMiddleware from 'Src/sagas/middleware';

// TODO: @jaebradley add LR and Sentry middlewares
const middlewares = [sagaMiddleware];

export default middlewares;
